import Enums from "../../../../enums/enums";
import Helper from "../../../../helper/merchantHelper";
export const mutations = {
  MutationsInsertMerchant(state, merchantId) {
    state.merchantId = merchantId;
    state.insertMerchantLoadingStatus = Enums.LoadingStatusType.Success;
  },
  MutationsSetSearchedMerchantAddressLoadingStatus(state, status) {
    state.searchedMerchantAddressLoadingStatus = status;
  },
  MutationsInputSearchedMerchantAddress(state, input) {
    state.inputSearchedMerchantAddress = input;
  },
  MutationsSearchedMerchantAddressType(state, addressType) {
    state.searchedMerchantAddressType = addressType;
  },
  MutationResetMerchantTemplate(state) {
    state.merchantTemplate = Helper.GetMerchantTemplateDefault();
    state.merchantId = 0;
    state.insertMerchantLoadingStatus = Enums.LoadingStatusType.None;
    state.searchedMerchantAddressLoadingStatus = Enums.LoadingStatusType.None;
    state.inputSearchedMerchantAddress = null;
    state.searchedMerchantAddressType = null;
  },
  MutationSetSampleMerchantLoadingStatus(state, status) {
    state.insertSampleMerchantLoadingStatus = status;
  },
  MutationSetSampleMerchantId(state, merchantId) {
    state.sampleMerchantId = merchantId;
  },
  MutationSetOnBoardingMerchantSampleLoadingStatus(state, status) {
    state.onBoardingMerchantSampleLoadingStatus = status;
  },
  MutationOnBoardingMerchantSample(state, onBoardingMerchantSample) {
    state.onBoardingMerchantSample = onBoardingMerchantSample;
  },
  MutationSetCreateContactMerchantSampleLoadingStatus(state, status) {
    state.createContactMerchantSampleLoadingStatus = status;
  },
  MutationSetCreateBankAccountMerchantSampleLoadingStatus(state, status) {
    state.createBankAccountMerchantSampleLoadingStatus = status;
  },
  MutationSetCreateProductMerchantSampleLoadingStatus(state, status) {
    state.createProductMerchantSampleLoadingStatus = status;
  },
  MutationSetCreateAllocationMerchantSampleLoadingStatus(state, status) {
    state.createAllocationMerchantSampleLoadingStatus = status;
  },
  MutationSetCreateQrCodeMerchantSampleLoadingStatus(state, status) {
    state.createQrCodeMerchantSampleLoadingStatus = status;
  },
  MutationSetCreateInvoiceMerchantSampleLoadingStatus(state, status) {
    state.createInvoiceMerchantSampleLoadingStatus = status;
  },
  MutationSetCreateInvoiceWithReceiptMerchantSampleLoadingStatus(state, status) {
    state.createInvoiceWithReceiptMerchantSampleLoadingStatus = status;
  },
  MutationSetCreateReceiptMerchantSampleLoadingStatus(state, status) {
    state.createReceiptMerchantSampleLoadingStatus = status;
  },
  MutationSetCreateExpenseMerchantSampleLoadingStatus(state, status) {
    state.createExpenseMerchantSampleLoadingStatus = status;
  },
  MutationSetCreateExpenseLazadaSetBefore2MonthMerchantSampleLoadingStatus(state, status) {
    state.createExpenseLazadaSetBefore2MonthMerchantSampleStatus = status;
  },
  MutationSetCreateExpenseLazadaSet2MonthMerchantSampleLoadingStatus(state, status) {
    state.createExpenseLazadaSet2MonthMerchantSampleStatus = status;
  },
  MutationSetCreateJournalMerchantSampleLoadingStatus(state, status) {
    state.createJournalMerchantSampleLoadingStatus = status;
  },
  MutationSetCreateCustomDashBoardMerchantSampleleLoadingStatus(state, status) {
    state.createCustomDashBoardMerchantSampleLoadingStatus = status;
  },
  MutationSetUpdateStatusMerchantSampleLoadingStatus(state, status) {
    state.updateStatusMerchantSampleLoadingStatus = status;
  },
  MutationSetCaptureTrialBalanceByMerchantLoadingStatus(state, status) {
    state.captureTrialBalanceByMerchantLoadingStatus = status;
  },
  MutationSetSuggestCreateMerchantMobile(state, status) {
    state.suggestCreateMerchantMobile = status;
  },
  MutationSetValidateTransferSuperAdminLoadingStatus(state, status) {
    state.validateTransferSuperAdminLoadingStatus = status;
  },

  MutationSetValidateTransferSuperAdmin(state, status) {
    state.validateTransferSuperAdmin = status;
  },
  MutationSetTransferSuperAdminLoadingStatus(state, status) {
    state.transferSuperAdminLoadingStatus = status;
  },
  MutationSetValidatePasswordLoadingStatus(state, status) {
    state.validatePasswordLoadingStatus = status;
  },
  MutationSetValidatePassword(state, status) {
    state.validatePassword = status;
  },
};
